import { WidgetBase, IWidgetConfiguration, WidgetQualityData } from '../../models';
import { Helper, WideError } from '../../../common';

import { QualityPercentageWidgetDefinition as definition } from './qualityPercentage.definition';
import { QualityPercentageConfiguration } from './qualityPercentage.configuration';
import { QualityWidgetType } from '../../../models';
import { computeError } from '../computeError';

export class QualityPercentageWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: QualityPercentageConfiguration;
    data?: WidgetQualityData;
    error?: WideError;
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(configuration: IWidgetConfiguration & { qualityWidgetType: QualityWidgetType }) {
        super();
        this.guid = Helper.getGuid();
        if (configuration) {
            this.configuration = configuration as any;
            this.name = configuration.name !== undefined ? configuration.name : this.name;
            this.sizeX = configuration.sizeX !== undefined ? configuration.sizeX : this.sizeX;
            this.sizeY = configuration.sizeY !== undefined ? configuration.sizeY : this.sizeY;
            this.row = configuration.row !== undefined ? configuration.row : this.row;
            this.col = configuration.col !== undefined ? configuration.col : this.col;
        } else {
            this.configuration = {
                bands: []
            } as any;
        }
    }
    
    getError(): WideError {
        return (this.data && this.data.results)
            ? computeError(this.data.results.percentage, this.configuration.bands, true)
            : null;
    }
}